import React from "react";
import { FormGroup, Label, FormFeedback, Input } from "reactstrap";
import { Typeahead } from "react-bootstrap-typeahead";

const TypeaheadSelect = ({
  name,
  items,
  label,
  error,
  textProperty,
  valueProperty,
  bold,
  required,
  ...rest
}) => {
  return (
    <FormGroup className={required ? "required" : ""}>
      <Label className={bold ? "font-weight-bold" : ""} for={name}>
        {label}
      </Label>
      <Typeahead
        {...rest}
        id={name}
        name={name}
        isInvalid={error ? true : false}
        placeholder={"Escolha um..."}
        options={items.map((item) => ({
          id: item[valueProperty],
          label: item[textProperty],
        }))}
      />
      <Input hidden invalid={error ? true : false} />
      <FormFeedback>{error}</FormFeedback>
    </FormGroup>
  );
};

TypeaheadSelect.defaultProps = {
  textProperty: "name",
  valueProperty: "id",
};

export default TypeaheadSelect;
